import { AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/utils'

const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL as string | undefined

function ContactUs() {
  return SUPPORT_EMAIL ? (
    <a
      href={`mailto:${SUPPORT_EMAIL}`}
      className="font-medium underline underline-offset-2"
    >
      contact us at {SUPPORT_EMAIL}
    </a>
  ) : (
    <span className="font-medium">contact ProfitFlow support</span>
  )
}

/**
 * Shown when the space's subscription has ended for good (cancelled or trial
 * expired). Stripe never re-activates a cancelled subscription — not even if an
 * old invoice is paid — so the only way forward is choosing a new plan.
 */
export default function EndedSubscriptionNotice({
  wasTrial = false,
  isOwner = true,
  className,
}: {
  wasTrial?: boolean
  isOwner?: boolean
  className?: string
}) {
  return (
    <div
      role="alert"
      className={cn(
        'rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-950',
        className,
      )}
    >
      <p className="flex items-center gap-2 font-semibold">
        <AlertTriangle className="size-4 shrink-0" />
        {wasTrial
          ? 'Your free trial has ended'
          : 'This subscription has been cancelled'}
      </p>
      <p className="mt-2">
        {isOwner
          ? 'To keep using this space, choose a new plan.'
          : 'The space owner needs to choose a new plan to restore access.'}
      </p>
      {isOwner && (
        <p className="mt-2">
          <strong>Please don&apos;t pay old invoices.</strong> A cancelled
          subscription can&apos;t be re-activated — Stripe won&apos;t restart it
          even if its invoice is paid. If you&apos;ve already paid an invoice
          after the cancellation, <ContactUs /> and we&apos;ll sort it out.
        </p>
      )}
    </div>
  )
}
